import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { CircleNotch } from "@phosphor-icons/react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-arena-bg text-arena-text font-mono flex items-center justify-center">
        <CircleNotch size={24} weight="bold" className="animate-spin text-arena-primary" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}
